import { createTranslations } from '@npco/utils-translations'

export const accountsTransactionsIncomeAndExpenseTranslations =
  createTranslations({
    errorTitle: 'Unable to load your transactions',
    errorDescription:
      'Something went wrong when loading your account transactions. Please make sure you’re connected to the internet and try again.',
  })
